import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { DoRuleService } from 'src/app/features/setting/service/do-rule.service'
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { Input } from '@angular/core';

@Component({
  selector: 'laas-do-rule-setting',
  templateUrl: './do-rule-setting.component.html',
  styleUrls: ['./do-rule-setting.component.scss']
})
export class DoRuleSettingComponent extends SessionBaseComponent implements OnInit {

  readonly preferenceKey: string;
  readonly noFacilityItems: any[] = ["AUTO_BOOKING", "AUTO_EXPORT", ""];
  isSearchFormOpen: boolean;
  searchForm!: FormGroup;
  searchParams: any;
  ruleOptions: any[];
  ruleSources: any[];
  facilityOptions: any[];
  checkTypeOptions: any[];
  doColumnOptions: any[];
  tenantOptions: any[];
  operatorOptions: any[];
  ifFlagOptions: any[];
  carCategoryOptions: any[];
  columns: any[];
  selectedCols: any[];
  ruleResults: any[];
  isLoading: boolean;

  //modify
  showModifyDialog: boolean;
  isInsert: boolean;
  modifyObject: any;

  //simulate
  showSimulateDialog: boolean;
  simulateParams: any;

  //simulate result
  showSimulateResultDialog: boolean;
  isSimulateResultLoading: boolean;
  simulateResults: any[];
  statusOptions: any[];

  constructor(
    injector: Injector,
    private fb: FormBuilder,
    private dropdownOptionsService: DropdownOptionsService,
    private doRuleService: DoRuleService
  ) {
    super(injector);
    this.isSearchFormOpen = true;
    this.isLoading = false;
    this.isInsert = true;
    this.showSimulateDialog = false;
    this.facilityOptions = [];
    this.doColumnOptions = [];
    this.tenantOptions = [];
    this.modifyObject = {};
    this.simulateParams = {};
    this.showSimulateResultDialog = false;
    this.isSimulateResultLoading = false;
    this.simulateResults = [];
    this.statusOptions = [{
      label:"尚未執行",
      value:'I'
    }, {
      label:"發生錯誤",
      value:'E'
    }, {
      label:"成功",
      value:'F'
    }];
    this.ifFlagOptions = [{
      label:"-",
      value:0
    },{
      label:"if",
      value:1
    }];
    this.operatorOptions = [{
      label: "請選擇",
      value: ""
    },{
      label: "等於",
      value: "eq"
    },{
      label: "不等於",
      value: "neq"
    },{
      label: "小於",
      value: "lt"
    },{
      label: "大於",
      value: "gt"
    },{
      label: "大於等於",
      value: "ge"
    },{
      label: "小於等於",
      value: "le"
    },{
      label: "相似",
      value: "like"
    },{
      label: "不相似",
      value: "nlike"
    },{
      label: "存在於",
      value: "in"
    },{
      label: "不存在於",
      value: "nin"
    },{
      label: "正規表示式",
      value: "regex"
    }];
    this.checkTypeOptions = [{
      label: "請選擇",
      value: ""
    },{
      label: "固定值",
      value: "Default"
    },{
      label: "欄位比對",
      value: "Col"
    },{
      label: "呼叫API",
      value: "API"
    }];

    this.carCategoryOptions = [{
      label: "請選擇",
      value: ""
    }, {
      label: "LOCAL",
      value: "LOCAL"
    }, {
      label: "RMB",
      value: "RMB"
    }, {
      label: "EXPORT",
      value: "EXPORT"
    }]

    this.searchParams = {
      ruleName: "",
      facility: ""
    };
    this.ruleResults = [];
    this.preferenceKey = UserPreferenceConstants.CustomerChopSignSearch;
    this.showModifyDialog = false;

    this.ruleSources = [{
      label: "啟用自動Booking(本地)",
      value: "AUTO_BOOKING"
    },{
      label: "啟用自動Booking(出口)",
      value: "AUTO_EXPORT"
    },{
      label: "產生Booking(出口)",
      value: "EXPORT"
    },{
      label: "產生Booking(本地)",
      value: "LOCAL"
    },{
      label: "產生Booking(轉交代理人)",
      value: "RMB"
    }];

    this.ruleOptions = [{
      label: "請選擇",
      value: ""
    },{
      label: "啟用自動Booking(本地)",
      value: "AUTO_BOOKING"
    },{
      label: "啟用自動Booking(出口)",
      value: "AUTO_EXPORT"
    }];

    this.columns = [
      { field: 'ruleOrder', header: '順序' },
      { field: 'ifFlag', header: 'If Flag' },
      { field: 'checkType', header: '檢核類型' },
      { field: 'field', header: '欄位名稱' },
      { field: 'operator', header: '運算子' },
      { field: 'value', header: '欄位值' },
      { field: 'orFlag', header: '(且/或) OrFalg' },
      { field: 'failMessage', header: '錯誤訊息' },
      { field: 'isDelete', header: '刪除' }
    ];

    this.selectedCols = this.columns;

    this.searchForm = this.fb.group({
      ruleName: ["", Validators.required],
      facility: "",
      carCategory: ""
    });
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();

    //get options
    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: result => {
        this.facilityOptions = [...result].map((x: any) => {
          return {
            value: x.optionCode,
            label: x.optionDesc
          }
        });

        this.facilityOptions.unshift({
          value: "",
          label: "共用"
        });

      }
    });

    this.doRuleService.getDoColumns().subscribe({
      next: result => {
        this.doColumnOptions = [...result].map((x: any) => {
          return {
            label: x.columnName,
            value: x.columnName
          }
        });
        this.doColumnOptions.unshift({
          label: "請選擇",
          value: ""
        });
      }
    });

    this.doRuleService.getTenantOptions().subscribe({
      next: result => {
        this.tenantOptions = [...result].map((x: any) => {
          return {
            label: x.tenantName,
            value: x.tenantCode
          }
        });

        this.tenantOptions.unshift({
          label: '請選擇',
          value: '',
        });
      }
    })


  }

  facilityChange(event: any): void{
    var ruleNameOptions = [...this.ruleSources].filter((x: any) => {
      if(this.searchParams.facility == ""){
        return x.value.startsWith("AUTO_");
      }else{
        return !x.value.startsWith("AUTO_");
      }
    });

    this.ruleOptions = ruleNameOptions;
    this.ruleOptions.unshift({
      label: '請選擇',
      value: '',
    });

    this.searchParams.ruleName = "";
    if(this.searchParams.facility == ""){
      this.searchParams.carCategory = "";
    }

    this.changeSearch(null);
  }

  changeSearch(event: any): void{
    this.searchClickBtn(null);
  }

  //search
  searchClickBtn(event: any): void{

    if(isNullOrEmpty(this.searchParams.ruleName)){
      return ;
    }

    this.isLoading = true;
    var facility = "";
    if(!isNullOrEmpty(this.searchParams.facility)){
      facility = this.searchParams.facility;
    }

    var carCategory = "";
    if(!isNullOrEmpty(this.searchParams.carCategory)){
      carCategory = this.searchParams.carCategory;
    }

    this.doRuleService.getDoRule(this.searchParams.ruleName, facility, carCategory).subscribe({
      next: result => {
        this.ruleResults = [...result];

        if(this.ruleResults.length > 0){
          this.ruleResults[0].ifFlag = 1;
        }

      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  addClickBtn(event: any): void{
    this.isInsert = true;
    this.showModifyDialog = true;
    this.modifyObject = {
      ifFlag: 0,
      facility: this.searchParams.facility,
      ruleName: this.searchParams.ruleName,
      carCategory: this.searchParams.carCategory
    };

    this.getMaxRuleOrder(this.modifyObject.ruleName, this.modifyObject.facility, this.modifyObject.carCategory);
  }

  editRule(event: any, rowData: any): void{
    this.isInsert = false;

    this.modifyObject.seqNo = rowData.seqNo;
    this.modifyObject.ruleName = rowData.ruleName;
    this.modifyObject.facility = rowData.facility;
    this.modifyObject.checkType = rowData.checkType;
    this.modifyObject.field = rowData.field;
    this.modifyObject.operator = rowData.operator;
    this.modifyObject.value = rowData.value;
    this.modifyObject.orFlagTmp = (rowData.orFlag == 1) ? true : false;
    this.modifyObject.ifFlag = rowData.ifFlag;
    this.modifyObject.ruleOrder = rowData.ruleOrder;
    this.modifyObject.failMessage = rowData.failMessage;

    this.showModifyDialog = true;
  }

  removeRule(event: any, rowData: any): void{
    var seqNo = rowData.seqNo;
    this.confirmationService.confirm({
      target: event.target,
      message: this.translateService.instant('DoRuleSetting.Confirm.ConfirmDelete'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
          //confirm action
          this.doRuleService.deleteDoRule(seqNo).subscribe({
            next: result => {
              this.toastService.info(this.translateService.instant('DoRuleSetting.Info.DeleteSuccess'));
            },
            complete: () => {
              this.searchClickBtn(null);
            }
          });
      },
      reject: () => {
          //reject action
      }
  });
  }

  getIfFlagWording(ifFlag: any, ruleOrder: number): string{
    if(ruleOrder == 1){
      return "If";
    }else{
      return (ifFlag == 1 ? "Or If" : "")
    }
  }

  modifyClick(event: any): void{
    if(this.isInsert){
      this.addDoRule();
    }else{
      this.updateDoRule();
    }
  }

  simulateClickBtn(event: any): void{
    this.showSimulateDialog = true;
    this.simulateParams = {};
  }

  simulateSaveClick(event: any): void{
    this.loader.show();

    // this.simulateParams.etaStart = isNullOrEmpty(this.simulateParams.etaStartTmp) ? null : new Date(this.simulateParams.etaStartTmp).toISOString();
    // this.simulateParams.etaEnd = isNullOrEmpty(this.simulateParams.etaEndTmp) ? null : new Date(this.simulateParams.etaEndTmp).toISOString();
    this.simulateParams.createDtStart = isNullOrEmpty(this.simulateParams.createDtStartTmp) ? null : new Date(this.simulateParams.createDtStartTmp).toISOString();
    this.simulateParams.createDtEnd = isNullOrEmpty(this.simulateParams.createDtEndTmp) ? null : new Date(this.simulateParams.createDtEndTmp).toISOString();
    this.simulateParams.forExport = this.simulateParams.forExportTmp ? 1 : 0;
    this.simulateParams.etdStart = isNullOrEmpty(this.simulateParams.etdStartTmp) ? null : new Date(this.simulateParams.etdStartTmp).toISOString();
    this.simulateParams.etdEnd = isNullOrEmpty(this.simulateParams.etdEndTmp) ? null : new Date(this.simulateParams.etdEndTmp).toISOString();

    this.doRuleService.saveSimulate(this.simulateParams).subscribe({
      next: result => {
        this.toastService.info(this.translateService.instant('DoRuleSetting.Info.SaveSuccess'));
      },
      complete: () => {
        this.showSimulateDialog = false;
        this.loader.hide();
      }
    })
  }

  simulateResultClickBtn(event: any): void{
    this.showSimulateResultDialog = true;
    this.getSimulateResult();
  }

  private updateDoRule(): void{
    this.loader.show();
    this.modifyObject.facility = isNullOrEmpty(this.modifyObject.facility) ? null : this.modifyObject.facility;
    this.modifyObject.userId = this.userProfile.loginAccount;
    this.modifyObject.orFlag = this.modifyObject.orFlagTmp ? 1 : 0;
    this.doRuleService.updateRule(this.modifyObject).subscribe({
      next: result => {
        this.toastService.info(this.translateService.instant('DoRuleSetting.Info.UpdateSuccess'));
      },
      complete: () => {
        this.searchClickBtn(null);
        this.showModifyDialog = false;
        this.loader.hide();
      }
    });
  }

  private addDoRule(): void{
    this.loader.show();
    this.modifyObject.facility = isNullOrEmpty(this.modifyObject.facility) ? null : this.modifyObject.facility;
    this.modifyObject.userId = this.userProfile.loginAccount;
    this.modifyObject.orFlag = this.modifyObject.orFlagTmp ? 1 : 0;
    this.doRuleService.addRule(this.modifyObject).subscribe({
      next: result => {
        this.toastService.info(this.translateService.instant('DoRuleSetting.Info.AddSuccess'));
      },
      complete: () => {
        this.searchClickBtn(null);
        this.showModifyDialog = false;
        this.loader.hide();
      }
    })
  }

  private getMaxRuleOrder(ruleName: string, facility: string, carCategory: string): void{

    var tmpFacility = "";
    if(!isNullOrEmpty(facility)){
      tmpFacility = facility;
    }

    var tmpCarCategory = "";
    if(!isNullOrEmpty(carCategory)){
      tmpCarCategory = carCategory;
    }

    this.doRuleService.getDoRule(ruleName, tmpFacility, tmpCarCategory).subscribe({
      next: result => {
        var maxRuleOrderArr = [...result].map((x: any) => {
          return x.ruleOrder;
        });

        var maxRuleOrder = Math.max(...maxRuleOrderArr);
        maxRuleOrder ++;

        if(maxRuleOrderArr.length > 0){
          this.modifyObject.ruleOrder = maxRuleOrder;
        }else{
          this.modifyObject.ruleOrder = 1;
        }
      }
    })
  }

  private getSimulateResult(): void{
    this.isSimulateResultLoading = true;
    this.doRuleService.getSimulateResult().subscribe({
      next: result => {
        this.simulateResults = result;
      },
      complete: () =>{
        this.isSimulateResultLoading = false;
      }
    });
  }

  getSimulateUrl(seqNo: number): string{
    return this.doRuleService.getDashBoardUrl() + "/" + seqNo;
  }

  importRuleClick(event: any): void{
    this.confirmationService.confirm({
      target: event.target,
      message:  this.translateService.instant('DoRuleSetting.Confirm.ConfirmImportData'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
          //confirm action
          this.doRuleService.importIntoTemp().subscribe({
            next: result => {
              this.toastService.info(this.translateService.instant('DoRuleSetting.Info.ImportSuccess'));
              this.changeSearch(null);
            }
          });
      },
      reject: () => {
          //reject action
      }
  });
  }

  exportRuleClick(event: any, conditionSeqNo: number): void{
    this.confirmationService.confirm({
      target: event.target,
      message: this.translateService.instant('DoRuleSetting.Confirm.OverwriteConfirmImportData'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
          //confirm action
          this.doRuleService.exportToReal(conditionSeqNo).subscribe({
            next: result => {
              this.toastService.info(this.translateService.instant('DoRuleSetting.Info.ImportSuccess'));
            }
          });
      },
      reject: () => {
          //reject action
      }
  });
  }
}

